module.exports = __webpack_public_path__ + "components/rewards/treads-and-trails/static/logo-a1fa8c72d37c97f22121ea0ea271eee2.jpg";